<template>
    <div class="text-center">
      <v-dialog v-model="dialog" width="800">
        <v-card> 
          <v-card-text class="pt-2">
            <div>
                <p class="mb-0"> <b>Estado:</b> {{ docPersona.estado }} </p>
                <p class="mb-0"> <b>Revision:</b> {{ docPersona.estadoRevision }} </p>
                <p class="mb-0"> <b>Presentado:</b> {{ parseFecha(docPersona.creadoEn) }} </p>
            </div>
            <object ref="refObjeto"/>
          </v-card-text>
  
          <v-divider></v-divider>
  
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disable="loading" text @click="dialog = false"> cerrar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
</template>

<script>

export default {
    components:{ },
    data () {
        return {
            dialog: false,
            loading: false,
            xins_id: 0,
            msg: '',
            docPersona: {},
        }
    },

    methods:{
        parseFecha(f){
            if(!f) return "";
            const p1 = f.split('T');
            const p2 = p1[1].split(':');
            return p1[0] +' '+p2[0]+':'+p2[1]
        },
        async openmodal(docPer){
            this.docPersona = docPer;
            let archivo = docPer.archivo;
            window.console.log('doscc',docPer);
            this.dialog = true;
            const url = `data:${archivo.mimetype};base64,${archivo.file64}`;    

           setTimeout(() => {
            this.$refs.refObjeto.data = url;
            this.$refs.refObjeto.type = archivo.mimetype;
            this.$refs.refObjeto.width = '100%';
            this.$refs.refObjeto.height = '600px';
           }, 300);
        },
    }
}
</script>

